import React from 'react'
import { View } from '../../Components'
import { chevron_right, gear } from '../../Images/Icons'
import { useNavigate } from 'react-router-dom'
import css from './ProfilePage.module.scss'

const ProfilePage = () => {

  const navigate = useNavigate();

  const station_get = localStorage.getItem("station_get");
  const username = localStorage.getItem("username");
  const email = localStorage.getItem("email");
  const station = JSON.parse(localStorage.getItem('station'));
  const data_user = station.filter(stat => stat.station_code === atob(station_get));

  const onSettingsClick = () => {
    navigate('/profile/settings'); 
  }

  return (
    <div>
      <div className={`mainHeader ${css.wrap_profile}`}>
        <label>P</label>
        <div className={css.wrap_profile_name}>
          {data_user[0].station_name}
        </div>
        <b>
          {data_user[0].power_kwp} kWp
        </b>
        <div className={css.wrap_profile_content}>
          <div className={css.wrap_profile_table}>
            <View justifyContent="space-between" style={{padding: 8}}>
              <div>Email</div>
              <div>{email}</div>
            </View>
            <View justifyContent="space-between" style={{padding: 8}}>
              <div>Username</div>
              <div>{username}</div>
            </View>
          </div>
        </div>
      </div> 
      <div className={css.wrap_menu_profile}>
        <div>
          <View onClick={onSettingsClick} justifyContent="space-between" className={css.item_menu}>
            <div><img src={gear} className={css.icon}/> Settings</div>
            <div><img id="svg-grey" src={chevron_right} className={css.arrow}  /></div>
          </View>
        </div>
      </div>
    </div>
  )
}

export default ProfilePage